import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const Feedback = ({ errors, success, globalError, mustSave, setSuccess }) => {
    useEffect(() => {
        if (!success) {
            return;
        }

        const timeout = setTimeout(() => setSuccess(false), 3000);

        return () => clearTimeout(timeout);
    }, [success, setSuccess]);

    return (
        <>
            {Object.keys(errors).length > 0 && (
                <p className="messaging -error -subtle">Please fix the errors below to continue</p>
            )}

            {!!success && <p className="messaging -success -subtle">Your information has been updated</p>}

            {!!globalError && (
                <p className="messaging -error -subtle">
                    An unknown error occurred - The account was not updated. Please try again.
                </p>
            )}

            {!!mustSave && <p className="messaging -error -subtle">Please save before changing tabs</p>}
        </>
    );
};

Feedback.propTypes = {
    errors: PropTypes.object.isRequired,
    success: PropTypes.bool.isRequired,
    globalError: PropTypes.bool.isRequired,
    mustSave: PropTypes.bool.isRequired,
    setSuccess: PropTypes.func.isRequired,
};

export default Feedback;
